<template>
  <div class="rp-root" data-aos="fade-right">
    <CrudToolbar
      title="Reporte de producción"
      v-model="filtro"
      searchPlaceholder="Buscar"
    >
      <template #extra>
        <CrudFechaRango v-model:fechaInicio="fechaInicio" v-model:fechaFin="fechaFin" />
      </template>
      <template #actions>
        <button
          class="btn-header btn-accion btn-generar"
          type="button"
          disabled
          title="Aún no definido cómo será"
        >
          <i class="bi bi-file-earmark-bar-graph"></i>
          <span class="btn-header-texto ms-2">Generar reporte</span>
        </button>
        <button
          class="btn-header btn-accion btn-exportar"
          type="button"
          :disabled="exportando"
          @click="exportar"
        >
          <span v-if="exportando" class="spinner-border spinner-border-sm"></span>
          <i v-else class="bi bi-file-earmark-excel-fill"></i>
          <span class="btn-header-texto ms-2">Exportar</span>
        </button>
        <button
          class="btn-header btn-accion btn-nuevo-rp"
          type="button"
          @click="abrirModalNuevo"
        >
          <i class="bi bi-plus-lg"></i>
          <span class="btn-header-texto ms-2">Nuevo registro</span>
        </button>
      </template>
    </CrudToolbar>

    <!-- ══ KPIs ══ -->
    <div class="rp-kpis">
      <div class="rp-kpi">
        <div class="rp-kpi-izq">
          <span class="rp-kpi-icono rp-kpi-icono--verde"
            ><i class="bi bi-box-seam-fill"></i
          ></span>
          <div>
            <span class="rp-kpi-label">Total producido</span>
            <span class="rp-kpi-valor">{{ formatNum(kpis.total_producido) }} <span class="rp-kpi-unidad">pzas</span></span>
          </div>
        </div>
        <span class="rp-kpi-sub">{{ kpis.registros ?? 0 }} registros</span>
      </div>
      <div class="rp-kpi">
        <div class="rp-kpi-izq">
          <span class="rp-kpi-icono rp-kpi-icono--azul"><i class="bi bi-box"></i></span>
          <div>
            <span class="rp-kpi-label">Modelos</span>
            <span class="rp-kpi-valor">{{ kpis.modelos_diferentes ?? 0 }}</span>
          </div>
        </div>
        <span class="rp-kpi-sub">diferentes</span>
      </div>
      <div class="rp-kpi">
        <div class="rp-kpi-izq">
          <span class="rp-kpi-icono rp-kpi-icono--morado"
            ><i class="bi bi-palette-fill"></i
          ></span>
          <div>
            <span class="rp-kpi-label">Colores</span>
            <span class="rp-kpi-valor">{{ kpis.colores_diferentes ?? 0 }}</span>
          </div>
        </div>
        <span class="rp-kpi-sub">diferentes</span>
      </div>
      <div class="rp-kpi">
        <div class="rp-kpi-izq">
          <span class="rp-kpi-icono rp-kpi-icono--amarillo"
            ><i class="bi bi-trash3-fill"></i
          ></span>
          <div>
            <span class="rp-kpi-label">Scrap total</span>
            <span class="rp-kpi-valor">{{ formatNum(kpis.scrap_total) }} <span class="rp-kpi-unidad">pzas</span></span>
          </div>
        </div>
        <span class="rp-kpi-sub">{{ kpis.porcentaje_scrap ?? 0 }}% del total</span>
      </div>
    </div>

    <!-- ══ TABS DE ESTATUS ══ -->
    <div class="rp-tabs">
      <button
        v-for="t in TABS"
        :key="t.valor"
        class="rp-tab"
        :class="['rp-tab--' + t.valor.toLowerCase(), { activo: tabActivo === t.valor }]"
        @click="cambiarTab(t.valor)"
      >
        <span class="rp-tab-icono" :class="'rp-tab-icono--' + t.valor.toLowerCase()">
          <i class="bi" :class="t.icono"></i>
        </span>
        <span class="rp-tab-label">{{ t.label }}</span>
        <span class="rp-tab-count">({{ conteos[t.valor] ?? 0 }})</span>
      </button>
    </div>

    <!-- ══ BARRA DE SELECCIÓN MASIVA ══ -->
    <div v-if="seleccionados.size > 0" class="rp-barra-seleccion">
      <span
        >{{ seleccionados.size }}
        {{
          seleccionados.size === 1 ? "reporte seleccionado" : "reportes seleccionados"
        }}</span
      >
      <div class="d-flex gap-2">
        <button
          class="btn-limpiar-seleccion"
          type="button"
          @click="seleccionados.clear()"
        >
          Limpiar
        </button>
        <button
          class="btn-enviar-aprobacion"
          type="button"
          :disabled="enviandoAprobacion"
          @click="confirmarEnvioAprobacion"
        >
          <span
            v-if="enviandoAprobacion"
            class="spinner-border spinner-border-sm me-2"
          ></span>
          <i v-else class="bi bi-send-fill me-1"></i>
          Enviar a aprobación
        </button>
      </div>
    </div>

    <!-- ══ TABLA ══ -->
    <div class="divisan-table-container shadow-lg">
      <div v-if="cargando" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
      </div>

      <!-- ── Vista detalle (reporte seleccionado) ── -->
      <template v-else-if="reporteSeleccionado">
        <div class="rp-detalle-header">
          <button
            class="btn-regresar"
            type="button"
            title="Regresar"
            aria-label="Regresar"
            @click="reporteSeleccionadoId = null"
          >
            <i class="bi bi-arrow-left"></i>
          </button>
          <div class="rp-detalle-info">
            <strong class="rp-fecha-larga">{{ formatFecha(reporteSeleccionado.fecha) }}</strong>
            <strong class="rp-fecha-corta">{{ formatFechaCorta(reporteSeleccionado.fecha) }}</strong>
            <span class="rp-detalle-encargado">
              <span class="rp-detalle-sep">·</span>
              <span>{{ reporteSeleccionado.encargado_nombre }}</span>
            </span>
            <span
              :class="['badge-estatus-rp', claseEstatus(reporteSeleccionado.estatus)]"
            >
              <span class="rp-estatus-largo">{{ reporteSeleccionado.estatus_display }}</span>
              <span class="rp-estatus-corto">{{ etiquetaCorta(reporteSeleccionado.estatus) }}</span>
            </span>
          </div>
        </div>
        <div class="table-scroll rp-vista-desktop">
          <table class="table table-divisan align-middle mb-0">
            <thead>
              <tr>
                <th
                  class="ps-4 th-ordenable"
                  style="width: 90px"
                  @click="ordenarLineasPor('maquina_nombre')"
                >
                  Máquina
                  <i
                    class="bi ms-1"
                    :class="
                      sortKeyLineas === 'maquina_nombre'
                        ? sortDirLineas === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                        : 'bi-arrow-down-up th-ordenable-hint'
                    "
                  ></i>
                </th>
                <th
                  class="rp-th-wrap th-ordenable"
                  style="width: 160px"
                  @click="ordenarLineasPor('operador_nombre')"
                >
                  Operador
                  <i
                    class="bi ms-1"
                    :class="
                      sortKeyLineas === 'operador_nombre'
                        ? sortDirLineas === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                        : 'bi-arrow-down-up th-ordenable-hint'
                    "
                  ></i>
                </th>
                <th
                  class="th-ordenable"
                  style="min-width: 190px"
                  @click="ordenarLineasPor('producto_nombre')"
                >
                  Producto / Modelo
                  <i
                    class="bi ms-1"
                    :class="
                      sortKeyLineas === 'producto_nombre'
                        ? sortDirLineas === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                        : 'bi-arrow-down-up th-ordenable-hint'
                    "
                  ></i>
                </th>
                <th
                  class="th-ordenable"
                  style="width: 110px"
                  @click="ordenarLineasPor('color_nombre')"
                >
                  Color
                  <i
                    class="bi ms-1"
                    :class="
                      sortKeyLineas === 'color_nombre'
                        ? sortDirLineas === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                        : 'bi-arrow-down-up th-ordenable-hint'
                    "
                  ></i>
                </th>
                <th class="text-center" style="width: 70px">Aditivo</th>
                <th
                  class="text-center th-ordenable"
                  style="width: 95px"
                  @click="ordenarLineasPor('cantidad_producida')"
                >
                  Cantidad
                  <i
                    class="bi ms-1"
                    :class="
                      sortKeyLineas === 'cantidad_producida'
                        ? sortDirLineas === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                        : 'bi-arrow-down-up th-ordenable-hint'
                    "
                  ></i>
                </th>
                <th
                  class="text-center th-ordenable"
                  style="width: 85px"
                  @click="ordenarLineasPor('scrap')"
                >
                  Scrap
                  <i
                    class="bi ms-1"
                    :class="
                      sortKeyLineas === 'scrap'
                        ? sortDirLineas === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                        : 'bi-arrow-down-up th-ordenable-hint'
                    "
                  ></i>
                </th>
                <th
                  class="text-center th-ordenable"
                  style="width: 85px"
                  @click="ordenarLineasPor('cantidad_neta')"
                >
                  Neto
                  <i
                    class="bi ms-1"
                    :class="
                      sortKeyLineas === 'cantidad_neta'
                        ? sortDirLineas === 'asc'
                          ? 'bi-arrow-up'
                          : 'bi-arrow-down'
                        : 'bi-arrow-down-up th-ordenable-hint'
                    "
                  ></i>
                </th>
                <th class="rp-th-wrap" style="width: 110px">Estatus</th>
                <th
                  v-if="reporteSeleccionado.estatus === 'PENDIENTE'"
                  class="text-center"
                  style="width: 90px"
                >
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="l in lineasPaginadas" :key="l.id">
                <td class="ps-4">{{ l.maquina_nombre }}</td>
                <td class="rp-celda-wrap">{{ l.operador_nombre }}</td>
                <td>
                  <span class="fw-bold text-cafe">{{ l.producto_nombre }}</span>
                  <small v-if="l.producto_modelo" class="d-block text-verde opacity-75">{{
                    l.producto_modelo
                  }}</small>
                </td>
                <td>
                  <span
                    v-if="l.color_hex"
                    class="rp-color-swatch"
                    :style="{ backgroundColor: l.color_hex }"
                  ></span>
                  <span>{{ l.color_nombre || "—" }}</span>
                </td>
                <td class="text-center">
                  <span :class="['badge-aditivo-rp', { activo: l.aditivo }]">{{
                    l.aditivo ? "C/A" : "S/A"
                  }}</span>
                </td>
                <td class="text-center">{{ formatNum(l.cantidad_producida) }}</td>
                <td class="text-center">{{ formatNum(l.scrap) }}</td>
                <td class="text-center fw-bold">{{ formatNum(l.cantidad_neta) }}</td>
                <td class="rp-celda-wrap">
                  <span
                    :class="[
                      'badge-estatus-rp',
                      claseEstatus(reporteSeleccionado.estatus),
                    ]"
                  >
                    {{ etiquetaCorta(reporteSeleccionado.estatus) }}
                  </span>
                </td>
                <td
                  v-if="reporteSeleccionado.estatus === 'PENDIENTE'"
                  class="text-center"
                >
                  <div class="d-flex justify-content-center gap-2">
                    <button
                      class="btn-circular"
                      :disabled="!reporteSeleccionado.puede_modificar"
                      @click="abrirModalEditarLinea(l)"
                      title="Editar renglón"
                    >
                      <i class="bi bi-pencil-square text-verde"></i>
                    </button>
                    <button
                      class="btn-circular text-danger"
                      :disabled="!reporteSeleccionado.puede_modificar"
                      @click="confirmarEliminarLinea(l)"
                      title="Eliminar renglón"
                    >
                      <i class="bi bi-trash3-fill"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ── Cards móvil (detalle) ── -->
        <div class="rp-vista-movil">
          <div
            v-for="l in lineasPaginadas"
            :key="'mob-' + l.id"
            class="rp-card"
            :class="claseEstatus(reporteSeleccionado.estatus)"
          >
            <div class="rp-linea-card-top">
              <span class="fw-bold text-cafe flex-grow-1">{{ l.producto_nombre }}</span>
              <span :class="['badge-aditivo-rp', { activo: l.aditivo }]">{{
                l.aditivo ? "C/A" : "S/A"
              }}</span>
            </div>
            <small v-if="l.producto_modelo" class="d-block text-verde opacity-75">{{
              l.producto_modelo
            }}</small>
            <div class="rp-linea-card-info">
              <span><i class="bi bi-gear-fill me-1"></i>{{ l.maquina_nombre }}</span>
              <span><i class="bi bi-person-fill me-1"></i>{{ l.operador_nombre }}</span>
              <span>
                <span
                  v-if="l.color_hex"
                  class="rp-color-swatch"
                  :style="{ backgroundColor: l.color_hex }"
                ></span>
                {{ l.color_nombre || "—" }}
              </span>
            </div>
            <div class="rp-card-stats rp-linea-card-stats">
              <div>
                <small>Cantidad</small><strong>{{ formatNum(l.cantidad_producida) }}</strong>
              </div>
              <div>
                <small>Scrap</small><strong>{{ formatNum(l.scrap) }}</strong>
              </div>
              <div>
                <small>Neto</small><strong>{{ formatNum(l.cantidad_neta) }}</strong>
              </div>
            </div>
            <div
              v-if="reporteSeleccionado.estatus === 'PENDIENTE'"
              class="rp-card-acciones"
            >
              <button
                class="btn-circular"
                :disabled="!reporteSeleccionado.puede_modificar"
                @click="abrirModalEditarLinea(l)"
                title="Editar renglón"
              >
                <i class="bi bi-pencil-square text-verde"></i>
              </button>
              <button
                class="btn-circular text-danger"
                :disabled="!reporteSeleccionado.puede_modificar"
                @click="confirmarEliminarLinea(l)"
                title="Eliminar renglón"
              >
                <i class="bi bi-trash3-fill"></i>
              </button>
            </div>
          </div>
          <p
            v-if="lineasPaginadas.length === 0"
            class="text-center py-5 text-cafe opacity-50 fw-bold"
          >
            No se encontraron renglones
          </p>
        </div>

        <!-- Paginación de la tabla de detalle -->
        <div class="paginacion-wrapper">
          <div class="pag-izq">
            <small class="pag-info"
              >{{ rangoInicioLineas }}–{{ rangoFinLineas }} de
              {{ lineasOrdenadas.length }} renglones</small
            >
            <div class="por-pagina-wrap">
              <label class="por-pagina-label">Filas:</label>
              <select
                class="por-pagina-select"
                :value="porPaginaLineas"
                @change="cambiarPorPaginaLineas(Number($event.target.value))"
              >
                <option
                  v-for="n in paginacionLineasStore.opcionesPorPagina"
                  :key="n"
                  :value="n"
                >
                  {{ n }}
                </option>
              </select>
            </div>
          </div>
          <div class="pag-der">
            <button
              class="btn-pag"
              :disabled="paginaLineas === 1"
              @click="paginaLineas = 1"
              title="Primera"
            >
              <i class="bi bi-chevron-double-left"></i>
            </button>
            <button
              class="btn-pag"
              :disabled="paginaLineas === 1"
              @click="paginaLineas--"
            >
              <i class="bi bi-chevron-left"></i>
            </button>
            <template v-for="p in paginasVisiblesLineas" :key="p">
              <span v-if="p === '...'" class="pag-ellipsis">…</span>
              <button
                v-else
                :class="['btn-pag-num', { activo: p === paginaLineas }]"
                @click="paginaLineas = p"
              >
                {{ p }}
              </button>
            </template>
            <button
              class="btn-pag"
              :disabled="paginaLineas === totalPaginasLineas"
              @click="paginaLineas++"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
            <button
              class="btn-pag"
              :disabled="paginaLineas === totalPaginasLineas"
              @click="paginaLineas = totalPaginasLineas"
              title="Última"
            >
              <i class="bi bi-chevron-double-right"></i>
            </button>
          </div>
        </div>
      </template>

      <!-- ── Vista resumen (lista de reportes) ── -->
      <template v-else>
        <div class="table-scroll rp-vista-desktop">
          <table class="table table-divisan align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-4" style="width: 36px">
                  <input
                    v-if="tabActivo === 'PENDIENTE' && reportes.length"
                    type="checkbox"
                    class="rp-checkbox"
                    :checked="todosSeleccionados"
                    @change="toggleSeleccionarTodos"
                  />
                </th>
                <th>No</th>
                <th>Fecha</th>
                <th>Encargado</th>
                <th class="text-center">Productos</th>
                <th class="text-center">Colores</th>
                <th class="text-center">Producción</th>
                <th class="text-center">Scrap</th>
                <th>Estatus</th>
                <th v-if="tabActivo === 'PENDIENTE'" class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(r, idx) in reportes"
                :key="r.id"
                class="rp-fila-clicable"
                @click="reporteSeleccionadoId = r.id"
              >
                <td class="ps-4" @click.stop>
                  <input
                    v-if="r.estatus === 'PENDIENTE'"
                    type="checkbox"
                    class="rp-checkbox"
                    :checked="seleccionados.has(r.id)"
                    @change="toggleSeleccionado(r.id)"
                  />
                </td>
                <td>{{ idx + 1 }}</td>
                <td>{{ formatFecha(r.fecha) }}</td>
                <td class="fw-bold text-cafe">{{ r.encargado_nombre }}</td>
                <td class="text-center">{{ r.total_productos }}</td>
                <td class="text-center">{{ r.total_colores }}</td>
                <td class="text-center">{{ formatNum(r.total_cantidad_producida) }}</td>
                <td class="text-center">{{ formatNum(r.total_scrap) }}</td>
                <td>
                  <span :class="['badge-estatus-rp', claseEstatus(r.estatus)]">{{
                    r.estatus_display
                  }}</span>
                </td>
                <td v-if="tabActivo === 'PENDIENTE'" class="text-center" @click.stop>
                  <div class="d-flex justify-content-center gap-2">
                    <button
                      class="btn-circular"
                      :disabled="!r.puede_modificar"
                      @click="abrirModalEditar(r)"
                      title="Editar"
                    >
                      <i class="bi bi-pencil-square text-verde"></i>
                    </button>
                    <button
                      class="btn-circular text-danger"
                      :disabled="!r.puede_modificar"
                      @click="confirmarCancelarReporte(r)"
                      title="Cancelar reporte"
                    >
                      <i class="bi bi-trash3-fill"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="reportes.length === 0">
                <td
                  :colspan="tabActivo === 'PENDIENTE' ? 10 : 9"
                  class="text-center py-5 text-cafe opacity-50 fw-bold"
                >
                  No se encontraron reportes
                </td>
              </tr>
            </tbody>
            <tfoot v-if="reportes.length">
              <tr class="rp-fila-totales">
                <td colspan="4" class="ps-4">
                  Mostrando {{ reportes.length }} registros
                </td>
                <td></td>
                <td></td>
                <td class="text-center">{{ formatNum(kpis.total_producido) }}</td>
                <td class="text-center">{{ formatNum(kpis.scrap_total) }}</td>
                <td :colspan="tabActivo === 'PENDIENTE' ? 2 : 1"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- ── Cards móvil ── -->
        <div class="rp-vista-movil">
          <div
            v-for="(r, idx) in reportes"
            :key="'mob-' + r.id"
            class="rp-card"
            :class="claseEstatus(r.estatus)"
            @click="reporteSeleccionadoId = r.id"
          >
            <span class="rp-card-no">#{{ idx + 1 }}</span>
            <div class="rp-card-top">
              <input
                v-if="r.estatus === 'PENDIENTE'"
                type="checkbox"
                class="rp-checkbox"
                :checked="seleccionados.has(r.id)"
                @click.stop
                @change="toggleSeleccionado(r.id)"
              />
              <span class="fw-bold text-cafe flex-grow-1">{{ r.encargado_nombre }}</span>
            </div>
            <div class="rp-card-meta">
              <span class="rp-card-fecha">{{ formatFecha(r.fecha) }}</span>
              <span :class="['badge-estatus-rp', claseEstatus(r.estatus)]">{{
                r.estatus_display
              }}</span>
            </div>
            <div class="rp-card-stats">
              <div>
                <small>Productos</small><strong>{{ r.total_productos }}</strong>
              </div>
              <div>
                <small>Colores</small><strong>{{ r.total_colores }}</strong>
              </div>
              <div>
                <small>Producción</small
                ><strong>{{ formatNum(r.total_cantidad_producida) }}</strong>
              </div>
              <div>
                <small>Scrap</small><strong>{{ formatNum(r.total_scrap) }}</strong>
              </div>
            </div>
            <div v-if="tabActivo === 'PENDIENTE'" class="rp-card-acciones" @click.stop>
              <button
                class="btn-circular"
                :disabled="!r.puede_modificar"
                @click="abrirModalEditar(r)"
                title="Editar"
              >
                <i class="bi bi-pencil-square text-verde"></i>
              </button>
              <button
                class="btn-circular text-danger"
                :disabled="!r.puede_modificar"
                @click="confirmarCancelarReporte(r)"
                title="Cancelar reporte"
              >
                <i class="bi bi-trash3-fill"></i>
              </button>
            </div>
          </div>
          <p
            v-if="reportes.length === 0"
            class="text-center py-5 text-cafe opacity-50 fw-bold"
          >
            No se encontraron reportes
          </p>
        </div>
      </template>
    </div>

    <!-- ══ MODAL NUEVO / EDITAR REPORTE ══ -->
    <div class="modal fade" tabindex="-1" aria-hidden="true" ref="modalReporteElement">
      <div class="modal-dialog modal-xl modal-dialog-centered rp-modal-dialog-reporte">
        <div class="modal-content divisan-modal border-0">
          <form @submit.prevent="guardarReporte" class="rp-form-reporte">
            <div class="modal-header border-0 pb-0 rp-modal-header">
              <div class="rp-modal-header-info">
                <h5 class="modal-title fw-bold text-cafe mb-0">
                  {{
                    formReporte.id
                      ? "Editar reporte de producción"
                      : "Nuevo reporte de producción"
                  }}
                </h5>
                <div class="rp-modal-header-meta">
                  <span class="rp-encargado-inline">
                    Encargado:
                    <strong>{{
                      formReporte.id ? formReporte.encargado_nombre : nombreUsuarioActual
                    }}</strong>
                  </span>
                  <input
                    v-model="formReporte.fecha"
                    type="date"
                    class="form-control form-control-sm divisan-input-modal rp-fecha-header"
                    required
                  />
                </div>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="rp-lineas-header">
                <span class="label-divisan fw-bold">Renglones del reporte</span>
                <button type="button" class="btn-agregar-renglon" @click="agregarRenglon">
                  <i class="bi bi-plus-lg me-1"></i>Agregar renglón
                </button>
              </div>

              <div class="table-scroll rp-tabla-renglones-scroll">
                <table class="table rp-tabla-renglones align-middle mb-0">
                  <thead>
                    <tr>
                      <!-- Anchos medidos con Inter a 0.85rem (SelectDropdown dense):
                           Máquina cabe "IMMI 10"; Operador cabe el nombre más
                           largo del catálogo (35 car., "Mariel Berenice Gonzalez
                           Guadarrama" ≈ 252px de texto + flecha y paddings).
                           Producto toma el resto del modal-xl. -->
                      <th style="width: 96px">Máquina</th>
                      <th style="width: 300px">Operador</th>
                      <th style="width: 400px">Producto</th>
                      <th style="width: 80px">Cantidad</th>
                      <th style="width: 80px">Scrap</th>
                      <th style="width: 80px">Neto</th>
                      <th style="width: 40px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(linea, i) in formReporte.lineas" :key="linea._key">
                      <td>
                        <SelectDropdown
                          v-model="linea.maquina"
                          :options="catMaquinas"
                          :option-value="(m) => m.id"
                          :option-label="(m) => m.nombre"
                          dense
                        />
                      </td>
                      <td>
                        <SelectDropdown
                          v-model="linea.operador"
                          :options="catOperadores"
                          :option-value="(o) => o.id"
                          :option-label="(o) => `${o.nombre} ${o.apellido}`"
                          dense
                        />
                      </td>
                      <td>
                        <SelectDropdown
                          v-model="linea.producto"
                          :options="catProductos"
                          :option-value="(p) => p.codigo"
                          :option-label="(p) => `${p.codigo} — ${p.nombre}`"
                          dense
                        />
                      </td>
                      <td>
                        <input
                          v-model="linea.cantidad_producida"
                          type="number"
                          min="0"
                          class="form-control divisan-input-modal"
                          required
                        />
                      </td>
                      <td>
                        <input
                          v-model="linea.scrap"
                          type="number"
                          min="0"
                          class="form-control divisan-input-modal"
                        />
                      </td>
                      <td>
                        <input
                          :value="netoRenglon(linea)"
                          type="number"
                          disabled
                          class="form-control divisan-input-modal"
                        />
                      </td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn-quitar-renglon"
                          :disabled="formReporte.lineas.length <= 1"
                          @click="quitarRenglon(i)"
                          title="Quitar renglón"
                        >
                          <i class="bi bi-x-lg"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer border-0 pt-0">
              <button
                type="submit"
                class="btn btn-nuevo w-100 py-2"
                :disabled="guardandoReporte"
              >
                <span
                  v-if="guardandoReporte"
                  class="spinner-border spinner-border-sm me-2"
                ></span>
                Guardar reporte
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- ══ MODAL EDITAR UN SOLO RENGLÓN (desde la vista detalle) ══ -->
    <div class="modal fade" tabindex="-1" aria-hidden="true" ref="modalLineaElement">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content divisan-modal border-0">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title fw-bold text-cafe">Editar renglón</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <form @submit.prevent="guardarLinea">
            <div class="modal-body">
              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">Máquina</label>
                  <SelectDropdown
                    v-model="formLinea.maquina"
                    :options="catMaquinas"
                    :option-value="(m) => m.id"
                    :option-label="(m) => m.nombre"
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">Operador</label>
                  <SelectDropdown
                    v-model="formLinea.operador"
                    :options="catOperadores"
                    :option-value="(o) => o.id"
                    :option-label="(o) => `${o.nombre} ${o.apellido}`"
                  />
                </div>
                <div class="col-12">
                  <label class="form-label label-divisan">Producto</label>
                  <SelectDropdown
                    v-model="formLinea.producto"
                    :options="catProductos"
                    :option-value="(p) => p.codigo"
                    :option-label="(p) => `${p.codigo} — ${p.nombre}`"
                  />
                </div>
                <div class="col-6">
                  <label class="form-label label-divisan small">Cantidad producida</label>
                  <input
                    v-model="formLinea.cantidad_producida"
                    type="number"
                    min="0"
                    class="form-control divisan-input-modal"
                    required
                  />
                </div>
                <div class="col-6">
                  <label class="form-label label-divisan small">Scrap</label>
                  <input
                    v-model="formLinea.scrap"
                    type="number"
                    min="0"
                    class="form-control divisan-input-modal"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 pt-0">
              <button
                type="submit"
                class="btn btn-nuevo w-100 py-2"
                :disabled="guardandoLinea"
              >
                <span
                  v-if="guardandoLinea"
                  class="spinner-border spinner-border-sm me-2"
                ></span>
                Guardar renglón
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { useAuthStore } from "@/store/useAuthStore";
import { usePaginacionLineasReporteProduccionStore } from "@/store/paginacionStore";
import CrudToolbar from "@/components/Shared/CrudToolbar.vue";
import CrudFechaRango from "@/components/Shared/CrudFechaRango.vue";
import SelectDropdown from "@/components/Shared/SelectDropdown.vue";
import {
  getReportesProduccion,
  getResumenReportesProduccion,
  crearReporteProduccion,
  actualizarReporteProduccion,
  cancelarReporteProduccion,
  actualizarLineaReporteProduccion,
  eliminarLineaReporteProduccion,
  enviarReportesAprobacion,
  exportarReportesProduccion,
  getCatalogoMaquinas,
  getOperadores,
  getCatalogoProductosCompleto,
} from "@/utils/api_backend";

const authStore = useAuthStore();
const nombreUsuarioActual = computed(
  () => `${authStore.userName} ${authStore.userApellido}`.trim() || "—"
);

const TABS = [
  { valor: "PENDIENTE", label: "Pendientes de recepción", icono: "bi-clock-history" },
  { valor: "ENVIADO", label: "Enviados a almacén", icono: "bi-send" },
  { valor: "COMPLETADO", label: "Recepción completada", icono: "bi-check-circle" },
];
function claseEstatus(v) {
  return "badge-estatus-rp--" + v.toLowerCase();
}

const ESTATUS_CORTO = {
  PENDIENTE: "Pendiente",
  ENVIADO: "Enviado",
  COMPLETADO: "Completado",
  CANCELADO: "Cancelado",
};
function etiquetaCorta(v) {
  return ESTATUS_CORTO[v] || v;
}

// ── Filtros / estado de la tabla ─────────────────────────────
const filtro = ref("");
const fechaInicio = ref("");
const fechaFin = ref("");
const tabActivo = ref("PENDIENTE");
const cargando = ref(false);
const reportes = ref([]);
const kpis = ref({});
const conteos = ref({ PENDIENTE: 0, ENVIADO: 0, COMPLETADO: 0, CANCELADO: 0 });
const reporteSeleccionadoId = ref(null);
const seleccionados = ref(new Set());
const exportando = ref(false);
const enviandoAprobacion = ref(false);

const reporteSeleccionado = computed(() =>
  reportes.value.find((r) => r.id === reporteSeleccionadoId.value)
);

// ── Ordenamiento y paginación de la tabla de detalle (líneas) ──
// Vive aparte de la paginación/orden de la tabla resumen de arriba, con su
// propio store, para que un ajuste acá no afecte a la otra tabla.
const paginacionLineasStore = usePaginacionLineasReporteProduccionStore();
const sortKeyLineas = ref(null);
const sortDirLineas = ref("asc");
const paginaLineas = ref(1);
const CAMPOS_NUMERICOS_LINEAS = new Set(["cantidad_producida", "scrap", "cantidad_neta"]);

function ordenarLineasPor(field) {
  if (sortKeyLineas.value === field) {
    sortDirLineas.value = sortDirLineas.value === "asc" ? "desc" : "asc";
  } else {
    sortKeyLineas.value = field;
    sortDirLineas.value = "asc";
  }
  paginaLineas.value = 1;
}

const lineasOrdenadas = computed(() => {
  const lineas = reporteSeleccionado.value?.lineas || [];
  if (!sortKeyLineas.value) return lineas;
  const campo = sortKeyLineas.value;
  const esNumerico = CAMPOS_NUMERICOS_LINEAS.has(campo);
  return [...lineas].sort((a, b) => {
    const cmp = esNumerico
      ? (a[campo] ?? 0) - (b[campo] ?? 0)
      : String(a[campo] ?? "").localeCompare(String(b[campo] ?? ""), "es", {
          sensitivity: "base",
          numeric: true,
        });
    return sortDirLineas.value === "asc" ? cmp : -cmp;
  });
});

const porPaginaLineas = computed(() => paginacionLineasStore.porPagina);
const totalPaginasLineas = computed(() =>
  Math.max(1, Math.ceil(lineasOrdenadas.value.length / porPaginaLineas.value))
);
const lineasPaginadas = computed(() => {
  const inicio = (paginaLineas.value - 1) * porPaginaLineas.value;
  return lineasOrdenadas.value.slice(inicio, inicio + porPaginaLineas.value);
});
const rangoInicioLineas = computed(() =>
  lineasOrdenadas.value.length === 0
    ? 0
    : (paginaLineas.value - 1) * porPaginaLineas.value + 1
);
const rangoFinLineas = computed(() =>
  Math.min(paginaLineas.value * porPaginaLineas.value, lineasOrdenadas.value.length)
);
const paginasVisiblesLineas = computed(() => {
  const total = totalPaginasLineas.value;
  const actual = paginaLineas.value;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const set = new Set([1, total, actual]);
  if (actual > 1) set.add(actual - 1);
  if (actual < total) set.add(actual + 1);
  const ordenadas = [...set].sort((a, b) => a - b);
  const resultado = [];
  for (let i = 0; i < ordenadas.length; i++) {
    if (i > 0 && ordenadas[i] - ordenadas[i - 1] > 1) resultado.push("...");
    resultado.push(ordenadas[i]);
  }
  return resultado;
});

function cambiarPorPaginaLineas(n) {
  paginacionLineasStore.setPorPagina(n);
  paginaLineas.value = 1;
}

watch(reporteSeleccionadoId, () => {
  paginaLineas.value = 1;
  sortKeyLineas.value = null;
  sortDirLineas.value = "asc";
});
const todosSeleccionados = computed(
  () =>
    reportes.value.length > 0 &&
    reportes.value.every((r) => seleccionados.value.has(r.id))
);

function paramsActuales() {
  const p = { estatus: tabActivo.value };
  if (filtro.value) p.search = filtro.value;
  if (fechaInicio.value && fechaFin.value) {
    p.fecha_inicio = fechaInicio.value;
    p.fecha_fin = fechaFin.value;
  }
  return p;
}

async function cargarReportes() {
  cargando.value = true;
  try {
    reportes.value = await getReportesProduccion(paramsActuales());
  } catch {
    Swal.fire("Error", "No se pudieron cargar los reportes de producción", "error");
  } finally {
    cargando.value = false;
  }
}

async function cargarResumen() {
  try {
    const data = await getResumenReportesProduccion(paramsActuales());
    kpis.value = data.kpis;
    conteos.value = data.conteos_por_estatus;
  } catch {
    // silencioso: los KPIs no son críticos para seguir usando la tabla
  }
}

async function cargarTodo() {
  reporteSeleccionadoId.value = null;
  await Promise.all([cargarReportes(), cargarResumen()]);
}

function cambiarTab(valor) {
  tabActivo.value = valor;
  seleccionados.value.clear();
}

watch([filtro, fechaInicio, fechaFin, tabActivo], () => {
  cargarTodo();
});

// ── Selección masiva + envío a aprobación ────────────────────
function toggleSeleccionado(id) {
  const set = new Set(seleccionados.value);
  if (set.has(id)) set.delete(id);
  else set.add(id);
  seleccionados.value = set;
}
function toggleSeleccionarTodos() {
  if (todosSeleccionados.value) {
    seleccionados.value = new Set();
  } else {
    seleccionados.value = new Set(reportes.value.map((r) => r.id));
  }
}

async function confirmarEnvioAprobacion() {
  const n = seleccionados.value.size;
  const res = await Swal.fire({
    title:
      n === 1 ? "¿Enviar 1 reporte a aprobación?" : `¿Enviar ${n} reportes a aprobación?`,
    text:
      "Una vez enviados, quedarán bloqueados para edición hasta que Almacén los revise.",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "var(--d-brown)",
    cancelButtonColor: "var(--d-green)",
  });
  if (!res.isConfirmed) return;

  enviandoAprobacion.value = true;
  try {
    const resultado = await enviarReportesAprobacion([...seleccionados.value]);
    seleccionados.value.clear();
    await cargarTodo();
    if (resultado.rechazados?.length) {
      Swal.fire(
        "Parcialmente enviado",
        `${resultado.enviados.length} reporte(s) enviados. ${resultado.rechazados.length} no se pudieron enviar.`,
        "warning"
      );
    } else {
      Swal.fire({
        icon: "success",
        title: "Enviado a aprobación",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  } catch {
    Swal.fire("Error", "No se pudo completar el envío a aprobación", "error");
  } finally {
    enviandoAprobacion.value = false;
  }
}

// ── Catálogos para el formulario ─────────────────────────────
const catMaquinas = ref([]);
const catOperadores = ref([]);
const catProductos = ref([]);

async function cargarCatalogos() {
  try {
    const [maquinas, operadores, productos] = await Promise.all([
      getCatalogoMaquinas(),
      getOperadores(),
      getCatalogoProductosCompleto(),
    ]);
    catMaquinas.value = maquinas;
    catOperadores.value = operadores;
    // Solo se reporta lo que se fabrica en el Taller; los productos de
    // importación no pasan por inyección.
    catProductos.value = productos.filter(
      (p) => p.activo && p.tipo === "FABRICACION"
    );
  } catch {
    Swal.fire(
      "Error",
      "No se pudieron cargar los catálogos (máquinas/operadores/productos)",
      "error"
    );
  }
}

// ── Modal Nuevo/Editar reporte ────────────────────────────────
const modalReporteElement = ref(null);
let modalReporteInstance = null;
const guardandoReporte = ref(false);
let contadorRenglon = 0;

function renglonVacio() {
  contadorRenglon += 1;
  return {
    _key: contadorRenglon,
    maquina: "",
    operador: "",
    producto: "",
    cantidad_producida: 0,
    scrap: 0,
  };
}

const formReporte = ref({
  id: null,
  fecha: "",
  encargado_nombre: "",
  lineas: [renglonVacio()],
});

function hoyISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
}

function abrirModalNuevo() {
  formReporte.value = {
    id: null,
    fecha: hoyISO(),
    encargado_nombre: "",
    lineas: [renglonVacio()],
  };
  modalReporteInstance.show();
}

function abrirModalEditar(reporte) {
  formReporte.value = {
    id: reporte.id,
    fecha: reporte.fecha,
    encargado_nombre: reporte.encargado_nombre,
    lineas: reporte.lineas.map((l) => ({
      _key: ++contadorRenglon,
      maquina: l.maquina,
      operador: l.operador,
      producto: l.producto,
      cantidad_producida: l.cantidad_producida,
      scrap: l.scrap,
    })),
  };
  modalReporteInstance.show();
}

function agregarRenglon() {
  formReporte.value.lineas.push(renglonVacio());
}
function netoRenglon(linea) {
  const cantidad = Number(linea.cantidad_producida) || 0;
  const scrap = Number(linea.scrap) || 0;
  return Math.max(cantidad - scrap, 0);
}
function quitarRenglon(i) {
  if (formReporte.value.lineas.length <= 1) return;
  formReporte.value.lineas.splice(i, 1);
}

async function guardarReporte() {
  guardandoReporte.value = true;
  try {
    const payload = {
      fecha: formReporte.value.fecha,
      lineas: formReporte.value.lineas.map((l) => ({
        maquina: l.maquina,
        operador: l.operador,
        producto: l.producto,
        cantidad_producida: Number(l.cantidad_producida) || 0,
        scrap: Number(l.scrap) || 0,
      })),
    };
    if (formReporte.value.id) {
      await actualizarReporteProduccion(formReporte.value.id, payload);
    } else {
      await crearReporteProduccion(payload);
    }
    await cargarTodo();
    modalReporteInstance.hide();
    Swal.fire({
      icon: "success",
      title: formReporte.value.id ? "Reporte actualizado" : "Reporte creado",
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (e) {
    const msg = e?.response?.data?.detail;
    Swal.fire(
      "Error",
      Array.isArray(msg) ? msg.join(" ") : msg || "No se pudo guardar el reporte",
      "error"
    );
  } finally {
    guardandoReporte.value = false;
  }
}

async function confirmarCancelarReporte(reporte) {
  const res = await Swal.fire({
    title: `¿Cancelar el reporte del ${formatFecha(reporte.fecha)}?`,
    text: "El reporte pasará a la pestaña de Cancelados.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, cancelar",
    cancelButtonText: "Regresar",
    confirmButtonColor: "var(--d-brown)",
    cancelButtonColor: "var(--d-green)",
  });
  if (!res.isConfirmed) return;
  try {
    await cancelarReporteProduccion(reporte.id);
    await cargarTodo();
    Swal.fire({
      icon: "success",
      title: "Reporte cancelado",
      timer: 1800,
      showConfirmButton: false,
    });
  } catch (e) {
    const msg = e?.response?.data?.detail;
    Swal.fire(
      "Error",
      Array.isArray(msg) ? msg.join(" ") : msg || "No se pudo cancelar el reporte",
      "error"
    );
  }
}

// ── Modal Editar un solo renglón (vista detalle) ──────────────
const modalLineaElement = ref(null);
let modalLineaInstance = null;
const guardandoLinea = ref(false);
const formLinea = ref({
  id: null,
  reporteId: null,
  maquina: "",
  operador: "",
  producto: "",
  cantidad_producida: 0,
  scrap: 0,
});

function abrirModalEditarLinea(linea) {
  formLinea.value = {
    id: linea.id,
    reporteId: reporteSeleccionadoId.value,
    maquina: linea.maquina,
    operador: linea.operador,
    producto: linea.producto,
    cantidad_producida: linea.cantidad_producida,
    scrap: linea.scrap,
  };
  modalLineaInstance.show();
}

async function guardarLinea() {
  guardandoLinea.value = true;
  try {
    await actualizarLineaReporteProduccion(
      formLinea.value.reporteId,
      formLinea.value.id,
      {
        maquina: formLinea.value.maquina,
        operador: formLinea.value.operador,
        producto: formLinea.value.producto,
        cantidad_producida: Number(formLinea.value.cantidad_producida) || 0,
        scrap: Number(formLinea.value.scrap) || 0,
      }
    );
    await cargarTodo();
    reporteSeleccionadoId.value = formLinea.value.reporteId;
    modalLineaInstance.hide();
    Swal.fire({
      icon: "success",
      title: "Renglón actualizado",
      timer: 1800,
      showConfirmButton: false,
    });
  } catch (e) {
    const msg = e?.response?.data?.detail;
    Swal.fire(
      "Error",
      Array.isArray(msg) ? msg.join(" ") : msg || "No se pudo guardar el renglón",
      "error"
    );
  } finally {
    guardandoLinea.value = false;
  }
}

async function confirmarEliminarLinea(linea) {
  const res = await Swal.fire({
    title: "¿Eliminar este renglón?",
    text: `${linea.producto_nombre} — ${linea.maquina_nombre}`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "var(--d-brown)",
    cancelButtonColor: "var(--d-green)",
  });
  if (!res.isConfirmed) return;
  const reporteId = reporteSeleccionadoId.value;
  try {
    await eliminarLineaReporteProduccion(reporteId, linea.id);
    await cargarTodo();
    reporteSeleccionadoId.value = reporteId;
    Swal.fire({
      icon: "success",
      title: "Renglón eliminado",
      timer: 1800,
      showConfirmButton: false,
    });
  } catch (e) {
    const msg = e?.response?.data?.detail;
    Swal.fire(
      "Error",
      Array.isArray(msg) ? msg.join(" ") : msg || "No se pudo eliminar el renglón",
      "error"
    );
  }
}

// ── Exportar ───────────────────────────────────────────────
async function exportar() {
  exportando.value = true;
  try {
    await exportarReportesProduccion(paramsActuales());
  } catch {
    Swal.fire("Error", "No se pudo exportar el reporte", "error");
  } finally {
    exportando.value = false;
  }
}

// ── Helpers de formato ────────────────────────────────────────
function formatNum(v) {
  return new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 }).format(v ?? 0);
}
function formatFecha(f) {
  if (!f) return "—";
  return new Date(f + "T12:00:00").toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
// Formato corto (dd/mm/yy) para la cabecera del detalle en pantallas
// angostas, donde el formato largo ya no cabe junto al estatus y el botón
// de regresar en un solo renglón.
function formatFechaCorta(f) {
  if (!f) return "—";
  const d = new Date(f + "T12:00:00");
  const dia = String(d.getDate()).padStart(2, "0");
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const anio = String(d.getFullYear()).slice(-2);
  return `${dia}/${mes}/${anio}`;
}

onMounted(() => {
  cargarTodo();
  cargarCatalogos();
  modalReporteInstance = new Modal(modalReporteElement.value);
  modalLineaInstance = new Modal(modalLineaElement.value);
});
</script>

<style scoped>
.rp-root {
  display: flex;
  flex-direction: column;
}
.text-cafe {
  color: var(--d-brown);
}
.text-verde {
  color: var(--d-green);
}

/* ── Ordenamiento y paginación de la tabla de detalle (líneas) —
   mismo diseño que el catálogo de Productos (CrudProductos.vue). ── */
.th-ordenable {
  cursor: pointer;
  user-select: none;
  transition: color 0.15s;
}
.th-ordenable:hover {
  color: var(--d-green);
}
.th-ordenable i {
  font-size: 0.7rem;
  color: var(--d-green);
}
.th-ordenable-hint {
  opacity: 0.35;
  transition: opacity 0.15s;
}
.th-ordenable:hover .th-ordenable-hint {
  opacity: 0.8;
}

.paginacion-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  flex-wrap: wrap;
  gap: 8px;
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background: rgba(96, 108, 56, 0.05);
}
.pag-izq {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.pag-der {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pag-info {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.por-pagina-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-select {
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23606c38' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 8px center;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  padding: 3px 26px 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-brown);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  min-width: 58px;
}
.por-pagina-select:focus,
.por-pagina-select:hover {
  border-color: var(--d-brown);
}
.btn-pag {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.35);
  color: var(--d-brown);
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.8rem;
}
.btn-pag:hover:not(:disabled) {
  background: var(--d-green);
  color: var(--d-cream);
  border-color: var(--d-green);
}
.btn-pag:disabled {
  opacity: 0.3;
  cursor: default;
}
.btn-pag-num {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.25);
  color: var(--d-brown);
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.82rem;
  font-weight: 700;
}
.btn-pag-num:hover {
  background: rgba(96, 108, 56, 0.1);
  border-color: var(--d-green);
}
.btn-pag-num.activo {
  background: var(--d-brown);
  color: var(--d-cream);
  border-color: var(--d-brown);
  pointer-events: none;
}
.pag-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 32px;
  font-size: 0.85rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}
@media (max-width: 768px) {
  .paginacion-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

/* ── Botones toolbar ── */
.btn-accion {
  border-radius: var(--d-radius-pill);
  padding: 7px 16px;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s;
}
.btn-accion:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-header {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
/* En el rango 992–1199.98px (sidebar expandido + rango de fechas + 3
   botones) el texto de los botones ya no cabe en una sola línea del
   toolbar y lo desborda sobre el panel de KPIs; se compactan a
   solo-ícono igual que en móvil para que todo quepa en un renglón. */
@media (max-width: 1199.98px) {
  .btn-header-texto {
    display: none;
  }
  .btn-header {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
}
.btn-generar {
  background: white;
  border: 1.5px dashed rgba(64, 34, 8, 0.3);
  color: var(--d-brown);
}
.btn-exportar {
  background: var(--d-info, #1565c0);
  border: 1.5px solid var(--d-info, #1565c0);
  color: white;
}
.btn-exportar:hover:not(:disabled) {
  background: #0d47a1;
}
.btn-nuevo-rp {
  background: var(--d-green);
  border: 1.5px solid var(--d-green);
  color: var(--d-cream);
}
.btn-nuevo-rp:hover {
  background: var(--d-green-dark);
}

/* Botón "Guardar" de los modales (fondo café, como en el resto de la app) */
.btn-nuevo {
  background-color: var(--d-brown);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
}
.btn-nuevo:hover:not(:disabled) {
  background-color: #703808;
  color: var(--d-cream);
}
.btn-nuevo:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── KPIs ── */
.rp-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 0px 0px 16px;
}
.rp-kpi {
  background: var(--d-cream);
  border-radius: 12px;
  box-shadow: var(--d-elevation-1);
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.rp-kpi-izq {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.rp-kpi-icono {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}
.rp-kpi-icono--verde {
  background: rgba(46, 125, 50, 0.14);
  color: #2e7d32;
}
.rp-kpi-icono--azul {
  background: rgba(21, 101, 192, 0.14);
  color: #1565c0;
}
.rp-kpi-icono--morado {
  background: rgba(106, 27, 154, 0.14);
  color: #6a1b9a;
}
.rp-kpi-icono--amarillo {
  background: rgba(212, 136, 4, 0.14);
  color: #d48804;
}
.rp-kpi-label {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--d-brown);
  opacity: 0.65;
}
.rp-kpi-valor {
  display: block;
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--d-brown);
  white-space: nowrap;
}
.rp-kpi-valor--chico {
  font-size: 0.85rem;
}
.rp-kpi-sub {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  background: rgba(96, 108, 56, 0.1);
  color: var(--d-green-dark);
  font-size: 0.74rem;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: var(--d-radius-pill);
  white-space: nowrap;
}

/* ── Tabs ── */
.rp-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  padding: 10px 16px;
  background: var(--d-cream);
  border-radius: var(--d-radius-lg);
  box-shadow: var(--d-elevation-1);
  margin-bottom: 14px;
}
.rp-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 3px 2px;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--d-brown);
  opacity: 0.55;
  cursor: pointer;
  transition: all 0.15s;
}
.rp-tab:hover {
  opacity: 0.85;
}
.rp-tab.activo {
  opacity: 1;
  color: var(--d-green-dark);
  border-bottom-color: var(--d-green);
}
.rp-tab-icono {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  font-size: 0.8rem;
  flex-shrink: 0;
}
.rp-tab-icono--pendiente {
  background: rgba(212, 136, 4, 0.16);
  color: #d48804;
}
.rp-tab-icono--enviado {
  background: rgba(21, 101, 192, 0.16);
  color: #1565c0;
}
.rp-tab-icono--completado {
  background: rgba(46, 125, 50, 0.16);
  color: #2e7d32;
}
.rp-tab-icono--cancelado {
  background: rgba(192, 57, 43, 0.16);
  color: #c0392b;
}

/* ── Barra de selección masiva ── */
.rp-barra-seleccion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--d-cream);
  border: 1px solid rgba(96, 108, 56, 0.25);
  border-radius: 10px;
  padding: 8px 14px;
  margin-bottom: 12px;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--d-green-dark);
}
.btn-limpiar-seleccion {
  background: none;
  border: 1px solid rgba(64, 34, 8, 0.3);
  color: var(--d-brown);
  border-radius: var(--d-radius-pill);
  padding: 4px 12px;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
}
.btn-enviar-aprobacion {
  background: var(--d-green);
  border: none;
  color: white;
  border-radius: var(--d-radius-pill);
  padding: 5px 14px;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.btn-enviar-aprobacion:disabled {
  opacity: 0.6;
  cursor: default;
}

/* ── Tabla ── */
.divisan-table-container {
  background-color: var(--d-cream);
  border-radius: var(--d-radius-lg);
  box-shadow: var(--d-elevation-2);
  overflow: hidden;
}
.table-scroll {
  overflow-x: auto;
}
.table-divisan thead th {
  background: var(--d-cream);
  color: var(--d-brown);
  border-bottom: 1px solid var(--d-border);
}
.table-divisan th {
  padding: 12px 15px;
  font-weight: 800;
  font-size: 0.74rem;
  text-transform: uppercase;
  border: none;
  white-space: nowrap;
}
.table-divisan td {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  padding: 10px 15px;
  white-space: nowrap;
  font-size: 0.85rem;
}
.table-divisan tbody tr:hover td {
  background-color: rgba(96, 108, 56, 0.05);
}
.rp-fila-clicable {
  cursor: pointer;
}
.rp-fila-totales td {
  font-weight: 800;
  color: var(--d-brown);
  background: rgba(96, 108, 56, 0.06);
  border-top: 2px solid rgba(96, 108, 56, 0.2);
}
.rp-checkbox {
  width: 16px;
  height: 16px;
  accent-color: var(--d-green);
  cursor: pointer;
}

/* ── Cards móvil (vista resumen) ── */
.rp-card {
  position: relative;
  background: white;
  border-radius: 12px;
  border-left: 5px solid rgba(96, 108, 56, 0.3);
  box-shadow: var(--d-elevation-1);
  padding: 12px 14px;
  margin: 5px 6px;
  cursor: pointer;
}
.rp-card.badge-estatus-rp--pendiente {
  border-left-color: #d48804;
}
.rp-card.badge-estatus-rp--enviado {
  border-left-color: #1565c0;
}
.rp-card.badge-estatus-rp--completado {
  border-left-color: #2e7d32;
}
.rp-card.badge-estatus-rp--cancelado {
  border-left-color: #c0392b;
}
.rp-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  padding-right: 42px;
}
.rp-card-no {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 0.68rem;
  font-weight: 800;
  color: white;
  background: var(--d-green);
  padding: 2px 9px;
  border-radius: 20px;
  line-height: 1.5;
}
.rp-card-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.rp-card-fecha {
  font-size: 0.78rem;
  color: var(--d-brown);
  opacity: 0.7;
}
.rp-card-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  padding: 8px 0;
  border-top: 1px dashed rgba(96, 108, 56, 0.2);
  border-bottom: 1px dashed rgba(96, 108, 56, 0.2);
  margin-bottom: 8px;
}
.rp-card-stats div {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.rp-card-stats small {
  font-size: 0.62rem;
  color: var(--d-brown);
  opacity: 0.6;
  text-transform: uppercase;
  font-weight: 700;
}
.rp-card-stats strong {
  font-size: 0.85rem;
  color: var(--d-brown);
}
.rp-card-acciones {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* ── Cards móvil de la tabla de detalle (renglones) ── */
.rp-linea-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rp-linea-card-info {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin: 6px 0;
  font-size: 0.78rem;
  color: var(--d-brown);
  opacity: 0.85;
}
.rp-linea-card-info i {
  color: var(--d-green);
  opacity: 0.8;
}
.rp-linea-card-stats {
  grid-template-columns: repeat(3, 1fr);
}

.btn-circular {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--d-green);
  transition: 0.2s;
}
.btn-circular:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-circular:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* ── Badges estatus / aditivo ── */
.badge-estatus-rp {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 800;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
}
.badge-estatus-rp--pendiente {
  background: #fff3cd;
  color: #7a5a00;
}
.badge-estatus-rp--enviado {
  background: #cfe2ff;
  color: #1565c0;
}
.badge-estatus-rp--completado {
  background: #d1e7dd;
  color: #0f5132;
}
.badge-estatus-rp--cancelado {
  background: #f8d7da;
  color: #842029;
}
.badge-aditivo-rp {
  display: inline-flex;
  min-width: 34px;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(64, 34, 8, 0.08);
  color: var(--d-brown);
  opacity: 0.6;
  font-size: 0.72rem;
  font-weight: 800;
}
.badge-aditivo-rp.activo {
  background: rgba(46, 125, 50, 0.14);
  color: #2e7d32;
  opacity: 1;
}

/* ── Vista detalle: columnas Operador/Estatus pueden partirse a dos
   renglones en vez de forzar el ancho de toda la tabla ── */
.rp-th-wrap {
  white-space: normal !important;
  text-align: left;
}
.rp-celda-wrap {
  white-space: normal !important;
  text-align: left;
  line-height: 1.25;
}
.rp-celda-wrap .badge-estatus-rp {
  white-space: normal;
  text-align: left;
  line-height: 1.2;
}
.rp-color-swatch {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1.5px solid rgba(64, 34, 8, 0.15);
  vertical-align: middle;
  margin-right: 8px;
}

/* ── Vista detalle ── */
.rp-detalle-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(96, 108, 56, 0.15);
  flex-wrap: wrap;
}
.btn-regresar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  background: var(--d-brown);
  color: var(--d-cream);
  border: none;
  border-radius: 50%;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.18s;
}
.btn-regresar:hover {
  background: #703808;
}
.rp-detalle-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--d-brown);
  font-size: 0.88rem;
}
.rp-detalle-sep {
  opacity: 0.4;
}
.rp-fecha-corta,
.rp-estatus-corto {
  display: none;
}
/* ── Cabecera del detalle en pantallas angostas: fecha corta (dd/mm/yy),
   estatus corto ("Pendiente" en vez de "Pendiente de recepción") y sin
   el nombre del encargado (ya se muestra en la tabla resumen) — así el
   botón de regresar, la fecha y el estatus caben en un solo renglón. ── */
@media (max-width: 425px) {
  .rp-fecha-larga,
  .rp-estatus-largo {
    display: none;
  }
  .rp-fecha-corta,
  .rp-estatus-corto {
    display: inline;
  }
  .rp-detalle-encargado {
    display: none;
  }
}

/* ── Modal reporte / renglones ── */
.divisan-modal {
  background-color: var(--d-cream);
  border: 2px solid var(--d-brown);
  border-radius: 20px;
}
.modal-dialog {
  margin-top: 4.5rem;
}
.label-divisan {
  color: var(--d-brown);
  font-weight: 700;
}
.divisan-input-modal {
  border: 1px solid var(--d-green);
  border-radius: 8px;
}
.divisan-input-modal:disabled {
  background-color: rgba(96, 108, 56, 0.08);
  opacity: 0.8;
}
.rp-modal-header {
  flex-wrap: wrap;
  gap: 8px 16px;
}
.rp-modal-header-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1 1 auto;
}
.rp-modal-header-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.rp-encargado-inline {
  font-size: 0.82rem;
  color: var(--d-brown);
  opacity: 0.85;
}
.rp-fecha-header {
  width: 150px;
}
/* ── Modal de reporte fijo en escritorio, con scroll interno en los
   renglones (header y footer siempre visibles) ── */
@media (min-width: 768px) {
  .rp-modal-dialog-reporte .modal-content {
    max-height: calc(100vh - 7rem);
    overflow: hidden;
  }
  .rp-form-reporte {
    display: flex;
    flex-direction: column;
    min-height: 0;
    flex: 1 1 auto;
    overflow: hidden;
  }
  .rp-form-reporte .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
  }
}
.rp-lineas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.btn-agregar-renglon {
  background: var(--d-green);
  color: white;
  border: none;
  border-radius: var(--d-radius-pill);
  padding: 5px 14px;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
}
/* table-layout: fixed para que las columnas respeten el ancho fijado en
   el thead — sin esto, un nombre largo de operador/producto hace crecer
   toda la tabla (el ellipsis del select nunca llega a aplicarse). */
.rp-tabla-renglones {
  table-layout: fixed;
}
.rp-tabla-renglones td {
  padding: 6px;
  vertical-align: middle;
}
.btn-quitar-renglon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid rgba(192, 57, 43, 0.4);
  background: white;
  color: #c0392b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-quitar-renglon:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* La tabla de renglones necesita scroll horizontal en pantallas chicas,
   pero el dropdown de cada select no debe cortarse verticalmente. */
.rp-tabla-renglones-scroll {
  overflow-x: auto;
  overflow-y: visible;
}

/* ── Toolbar en tablet (576–991.98px): buscador, fechas y botones caben
   en un solo renglón — el buscador crece para llenar el espacio libre
   en vez de quedar angosto con espacio suelto a la derecha. ── */
@media (min-width: 576px) and (max-width: 991.98px) {
  :deep(.crud-toolbar) {
    gap: 8px !important;
  }
  :deep(.crud-toolbar-center) {
    order: 1 !important;
    flex: 1 1 160px !important;
    justify-content: flex-start !important;
    min-width: 0 !important;
  }
  :deep(.crud-toolbar-search) {
    max-width: none !important;
  }
  :deep(.crud-toolbar-extra) {
    order: 2 !important;
    flex: 0 0 auto !important;
  }
  :deep(.crud-toolbar-actions) {
    order: 3 !important;
    gap: 6px !important;
    flex-shrink: 0 !important;
  }
}

/* ── Toolbar en móvil (<576px): ya no caben en un renglón — buscador +
   botones arriba, rango de fechas abajo — pero ambos renglones usan
   todo el ancho disponible en vez de quedar angostos. ── */
@media (max-width: 575.98px) {
  :deep(.crud-toolbar) {
    gap: 8px !important;
    flex-wrap: wrap !important;
  }
  :deep(.crud-toolbar-center) {
    order: 1 !important;
    /* flex-basis en 0 (en vez de "auto") para que el ancho natural del
       input de búsqueda no cuente al decidir si los botones caben en el
       mismo renglón — así el buscador parte de 0 y el flex-grow le da
       justo el espacio que sobra junto a los botones. */
    flex: 1 1 0 !important;
    justify-content: flex-start !important;
    min-width: 0 !important;
  }
  :deep(.crud-toolbar-search) {
    max-width: none !important;
  }
  :deep(.crud-toolbar-actions) {
    order: 1 !important;
    margin-left: auto !important;
    gap: 6px !important;
    flex-shrink: 0 !important;
  }
  :deep(.crud-toolbar-extra) {
    order: 2 !important;
    flex: 1 1 100% !important;
    width: 100% !important;
  }
  :deep(.rango-fechas) {
    width: 100%;
  }
  :deep(.fecha-input) {
    flex: 1 1 0;
    min-width: 0;
  }
}
@media (max-width: 360px) {
  :deep(.btn-header) {
    width: 30px !important;
    height: 30px !important;
    font-size: 0.78rem !important;
  }
  /* A esta medida la tarjeta ya no tiene espacio para "pzas" junto al
     número y lo empuja fuera del recuadro — se quita solo aquí. */
  .rp-kpi-unidad {
    display: none;
  }
}

/* ── KPIs en tablet: 2 columnas para que quepan etiqueta + valor ──
   Sube hasta 1024px: el modo responsive de esta pantalla arranca ahí
   (ver .rp-vista-desktop/.rp-vista-movil más abajo), no en el lg de
   Bootstrap (992px) — a esa medida 4 columnas se amontonaban. ── */
@media (max-width: 1024px) and (min-width: 576px) {
  .rp-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* ── Tabla de escritorio vs. cards móvil: el quiebre es 1024px (no el lg
   de Bootstrap/992px) — a 992-1024px la tabla ya no cabía completa y
   obligaba a hacer scroll horizontal para ver Estatus/Acciones. ── */
.rp-vista-desktop {
  display: none;
}
.rp-vista-movil {
  display: block;
}
@media (min-width: 1025px) {
  .rp-vista-desktop {
    display: block;
  }
  .rp-vista-movil {
    display: none;
  }
}

/* ── KPIs en móvil: solo ícono + número, los 4 en un renglón ── */
@media (max-width: 575.98px) {
  .rp-kpi {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 10px 4px;
    text-align: center;
  }
  .rp-kpi-izq {
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }
  .rp-kpi-icono {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }
  .rp-kpi-label,
  .rp-kpi-sub {
    display: none;
  }
  .rp-kpi-valor {
    font-size: 0.85rem;
    white-space: nowrap;
  }

  /* ── Tabs en móvil: pastilla coloreada con ícono + contador en fila ── */
  .rp-tabs {
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: 6px;
    padding: 8px 10px;
  }
  .rp-tab {
    flex: 1 1 0;
    flex-direction: row;
    justify-content: center;
    gap: 5px;
    border-bottom: none;
    border-radius: 999px;
    opacity: 1;
  }
  .rp-tab-icono {
    background: transparent !important;
    width: auto;
    height: auto;
    font-size: 0.95rem;
  }
  .rp-tab--pendiente {
    background: rgba(212, 136, 4, 0.14);
    color: #d48804;
  }
  .rp-tab--enviado {
    background: rgba(21, 101, 192, 0.14);
    color: #1565c0;
  }
  .rp-tab--completado {
    background: rgba(46, 125, 50, 0.14);
    color: #2e7d32;
  }
  .rp-tab--cancelado {
    background: rgba(192, 57, 43, 0.14);
    color: #c0392b;
  }
  .rp-tab.activo {
    box-shadow: inset 0 0 0 1.5px currentColor;
  }
  .rp-tab-label {
    display: none;
  }
  .rp-tab-count {
    font-size: 0.78rem;
    font-weight: 800;
    color: inherit;
  }
}
</style>
